export const REVENUE_INTELLIGENCE_COPY = {
  dealValue: "Deal value",
  forecast: {
    confidenceTooltip: "Agreement between CRM forecast and Revelate forecast. It is not a win probability.",
    crmContribution: "CRM forecast",
    crmContributionTooltip: "This Deal's stage-weighted value in the CRM forecast.",
    crmOverstatesValue: "CRM overstates value",
    crmOverstatesValueEmpty: "No Deals where CRM is above Revelate.",
    crmOverstatesValueSummary: "Revelate expects less from these Deals.",
    currentForecast: "Current forecast",
    difference: "Difference",
    forecastDependencies: "Forecast depends on",
    forecastSignals: "Forecast signals",
    keyDeals: "Key Deals",
    movedOutOfPeriod: "Moved out of period",
    movedOutOfPeriodEmpty: "No Deals expected after this period.",
    movedOutOfPeriodSummary: "Revelate expects these Deals to close later than CRM.",
    crmUnderstatesValue: "CRM understates value",
    crmUnderstatesValueEmpty: "No Deals where CRM understates value.",
    crmUnderstatesValueSummary: "CRM includes less than the Revelate forecast.",
    revelateContribution: "Revelate forecast",
    revelateContributionTooltip: "This Deal's value in the Revelate forecast.",
    forecastComparisonTooltip: "CRM forecast is stage weighted. Revelate forecast uses Deal signals and expected close timing.",
    forecastSupport: "Supported by current Deal signals.",
    revelateExpects: "Revelate expects",
    revelateForecast: "Revelate forecast",
    scenario: {
      impactCondition: (event: "lost" | "moved-out" | "moved-in" | "won", period: string) => ({
        lost: "if lost",
        "moved-out": `if moved out of ${period}`,
        "moved-in": `if moved into ${period}`,
        won: `if won ${period}`,
      })[event],
      downsideLost: "Lost.",
      downsideLostGroup: (dealCount: number) => `${dealCount} at-risk Deals are lost.`,
      downsideMovedOut: "Moved out of the period.",
      downsideMovedOutGroup: (dealCount: number, periodLabel: string) => `${dealCount} Deals move out of ${periodLabel}.`,
      upsideMovedIn: (periodLabel: string) => `Moved into ${periodLabel}.`,
      upsideMovedInGroup: (dealCount: number, periodLabel: string) => `${dealCount} Deals move into ${periodLabel}.`,
      upsideWon: (periodLabel: string) => `Won ${periodLabel}.`,
      upsideWonGroup: (dealCount: number, periodLabel: string) => `${dealCount} Deals are won ${periodLabel}.`,
    },
    whyTheGap: "The sales forecast is compared with Deal signals and expected close timing.",
  },
} as const;
